import React, { FC, useEffect, useState } from "react";
import { Account } from "react-aad-msal";
import { State } from "../../store";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as ActivityLogsStore from "../../store/ActivityLogsStore";
import * as GeneralStore from "../../store/GeneralStore";
import * as LineHandlingStore from "../../store/LineHandlingStore";
import * as OfflineDataStore from "../../store/OfflineDataStore";
import * as ProcessFlowConfigStore from "../../store/ProcessFlowConfigStore";
import * as SofViewStore from "../../store/SofViewStore";
import * as WorkPacketStore from "../../store/WorkPacketStore";
import { useParams } from "react-router";
// import ActivitiesGrid from "./ActivitiesGrid";
import { SofView } from "../../models/SofView";
import { FaArrowLeft, FaRegStopCircle, FaRegClock } from "react-icons/fa";
import { IoIosTrendingUp } from "react-icons/io";
import { AiOutlineSetting, AiOutlineWarning } from "react-icons/ai";
import './tank.css';
import CriticalMeasureGauge from "./CriticalMeasureGauge";
import { capitalizeFirstLetterPerWord } from "../../services/Helper";
import TankHistoricalChart from "./TankHistoricalChart";
import NominationDetailBtn from "./NominationDetailBtn";
import TankDisclaimer from "./TankDisclaimer";

const tankDetailFields = [
    { key: 'customer', label: 'Customer' },
    { key: 'product', label: 'Chemical' },
    { key: 'available', label: 'Available', suffix: 'metric tons' },
    { key: 'mode', label: 'Tank Mode' },
    { key: 'status', label: 'Tank Status' },
];

const criticalMeasureFields = [
    { key: 'level', maxValue: 100, minValue: 0, suffix: 'FT' },
    { key: 'temperature', maxValue: 200, minValue: 0, suffix: '&#8457;' },
    { key: 'flow', maxValue: 4000, minValue: 0, suffix: 'PBH' },
    { key: 'pressure', maxValue: 2, minValue: -2, suffix: "WC''" },
];

export type ISofProps = ActivityLogsStore.ActivityLogsState &
    GeneralStore.GeneralState &
    OfflineDataStore.OfflineDataState &
    ProcessFlowConfigStore.ProcessFlowConfigState &
    SofViewStore.SofViewState &
    WorkPacketStore.WorkPacketState &
    LineHandlingStore.LineHandlingState &
    typeof ActivityLogsStore.actionCreators &
    typeof OfflineDataStore.actionCreators &
    typeof ProcessFlowConfigStore.actionCreators &
    typeof SofViewStore.actionCreators & {
        account: Account;
    } & typeof GeneralStore.actionCreators &
    typeof WorkPacketStore.actionCreators;
const TankSofPage: FC<ISofProps> = (props: ISofProps) => {
    const [isTransferDetails, setIsTransferDetails] = useState(false);
    const { selectedState } = props;
    let param = useParams() as any;
    const { nominationNo } = param;
    const nomination = {
        "tank": "Tank 125",
        "mode": "Idle",
        "status": "Out of Service",
        "alarm": "Leak Detect",
        "customer": "KRATON CHEMICAL, LLC",
        "product": "Sylvapine ACS",
        "available": 3202.82528125,
        "criticalMeasurements": {
            "level": {
                "displayName": "LIT-125-01",
                "fieldName": "LIT-0125-0001",
                "processValue": 63.797000885009766,
                "setPoint": 50.0,
                "hihiAlarm": {
                    "setPoint": 66.6240005493164,
                },
                "hiAlarm": {
                    "setPoint": 65.58499908447266
                },
                "loAlarm": {},
                "loloAlarm": {},
                "valueMin": 0.0,
                "valueMax": 67.5
            },
            "temperature": {
                "displayName": "TIT-125-03",
                "fieldName": "TIT-0125-0003",
                "processValue": 83.98999786376953,
                "setPoint": 50.0,
                "hihiAlarm": {
                    "setPoint": 90.0
                },
                "hiAlarm": {
                    "setPoint": 85.0
                },
                "loAlarm": {
                    "setPoint": 36.0
                },
                "loloAlarm": {
                    "setPoint": 32.0
                },
                "valueMin": 0.0,
                "valueMax": 150.0
            },
            "flow": {
                "displayName": "FIT-125-RATE",
                "fieldName": "FIT-0125-RATE",
                "processValue": 0.479,
                "setPoint": 0.0,
                "hihiAlarm": {},
                "hiAlarm": {},
                "loAlarm": {},
                "loloAlarm": {},
                "valueMin": 0.0,
                "valueMax": 4000.0
            },
            "pressure": {
                "displayName": "PIT-125-01",
                "fieldName": "PIT-0125-0001",
                "processValue": 9.219797134399414,
                "setPoint": 50.0,
                "hihiAlarm": {
                    "setPoint": 37.0
                },
                "hiAlarm": {
                    "setPoint": 35.0
                },
                "loAlarm": {
                    "setPoint": 5.0
                },
                "loloAlarm": {
                    "setPoint": -1.0
                },
                "valueMin": -10.0,
                "valueMax": 90.0
            }
        },
        "nominationDetails": {
            "nominationId": "",
            "nominationNr": "OTH-2024-013757",
            "nominationIt": "0000000010",
            "nominationSt": "1",
            "customerName": "KRATON CHEMICAL, LLC",
            "customerPo": "80536934",
            "productName": "Sylvapine ACS",
            "poundsPerGallon": "",
            "sloc": "",
            "activity": "",
            "direction": "STATIC",
            "promiseDate": "2024-08-05T06:57:56.0198649+00:00",
            "requestedQty": 45000.0,
            "minimumQty": 44325.0,
            "maximumQty": 45675.0,
            "loadingStation": "",
            "created": "2024-07-16T18:46:40",
            "updated": "2024-08-01T23:47:38"
        }
    };

    const { tank, criticalMeasurements, valves, pumps, alarm, orderDetails, transferDetails, ...tankDetails }: any = nomination;


    const chartData = {
        level: [
            { timeNo: '2024-08-05T00:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T01:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T02:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T03:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T04:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T05:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T06:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T07:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T08:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T09:00:00.0000000Z', value: 16.8 },
            { timeNo: '2024-08-05T10:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T11:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T12:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T13:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T14:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T15:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T16:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T17:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T18:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T19:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T20:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T21:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T22:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-05T23:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T00:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T01:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T02:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T03:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T04:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T05:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T06:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T07:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T08:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T09:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T10:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T11:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T12:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T13:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T14:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T15:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T16:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T17:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T18:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T19:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T20:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T21:00:00.0000000Z', value: 16.79 },
            { timeNo: '2024-08-06T22:00:00.0000000Z', value: 16.79 },
        ],
        temperature: [
            { timeNo: '2024-08-05T00:00:00.0000000Z', value: 83.98 },
            { timeNo: '2024-08-05T01:00:00.0000000Z', value: 83.99 },
            { timeNo: '2024-08-05T02:00:00.0000000Z', value: 83.99 },
            { timeNo: '2024-08-05T03:00:00.0000000Z', value: 83.99 },
            { timeNo: '2024-08-05T04:00:00.0000000Z', value: 83.99 },
            { timeNo: '2024-08-05T05:00:00.0000000Z', value: 83.98 },
            { timeNo: '2024-08-05T06:00:00.0000000Z', value: 83.98 },
            { timeNo: '2024-08-05T07:00:00.0000000Z', value: 83.98 },
            { timeNo: '2024-08-05T08:00:00.0000000Z', value: 83.96 },
            { timeNo: '2024-08-05T09:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T10:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T11:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T12:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T13:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T14:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T15:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T16:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T17:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T18:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T19:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T20:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T21:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T22:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-05T23:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T00:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T01:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T02:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T03:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T04:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T05:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T06:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T07:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T08:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T09:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T10:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T11:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T12:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T13:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T14:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T15:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T16:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T17:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T18:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T19:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T20:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T21:00:00.0000000Z', value: 83.95 },
            { timeNo: '2024-08-06T22:00:00.0000000Z', value: 83.95 },
        ],
        flow: [
            { timeNo: '2024-08-05T00:00:00.0000000Z', value: 1.3 },
            { timeNo: '2024-08-05T01:00:00.0000000Z', value: 1.24 },
            { timeNo: '2024-08-05T02:00:00.0000000Z', value: 1.29 },
            { timeNo: '2024-08-05T03:00:00.0000000Z', value: 1.4 },
            { timeNo: '2024-08-05T04:00:00.0000000Z', value: 1.18 },
            { timeNo: '2024-08-05T05:00:00.0000000Z', value: 1.03 },
            { timeNo: '2024-08-05T06:00:00.0000000Z', value: 1.35 },
            { timeNo: '2024-08-05T07:00:00.0000000Z', value: 1.55 },
            { timeNo: '2024-08-05T08:00:00.0000000Z', value: 2.5 },
            { timeNo: '2024-08-05T09:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T10:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T11:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T12:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T13:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T14:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T15:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T16:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T17:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T18:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T19:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T20:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T21:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T22:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-05T23:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T00:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T01:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T02:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T03:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T04:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T05:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T06:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T07:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T08:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T09:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T10:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T11:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T12:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T13:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T14:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T15:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T16:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T17:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T18:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T19:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T20:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T21:00:00.0000000Z', value: 3.29 },
            { timeNo: '2024-08-06T22:00:00.0000000Z', value: 3.29 },
        ],
        pressure: [
            { timeNo: '2024-08-05T00:00:00.0000000Z', value: 10.27 },
            { timeNo: '2024-08-05T01:00:00.0000000Z', value: 9.52 },
            { timeNo: '2024-08-05T02:00:00.0000000Z', value: 9.08 },
            { timeNo: '2024-08-05T03:00:00.0000000Z', value: 9.19 },
            { timeNo: '2024-08-05T04:00:00.0000000Z', value: 9.18 },
            { timeNo: '2024-08-05T05:00:00.0000000Z', value: 8.75 },
            { timeNo: '2024-08-05T06:00:00.0000000Z', value: 8.3 },
            { timeNo: '2024-08-05T07:00:00.0000000Z', value: 8.05 },
            { timeNo: '2024-08-05T08:00:00.0000000Z', value: 9.43 },
            { timeNo: '2024-08-05T09:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T10:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T11:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T12:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T13:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T14:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T15:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T16:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T17:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T18:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T19:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T20:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T21:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T22:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-05T23:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T00:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T01:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T02:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T03:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T04:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T05:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T06:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T07:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T08:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T09:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T10:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T11:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T12:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T13:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T14:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T15:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T16:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T17:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T18:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T19:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T20:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T21:00:00.0000000Z', value: 10.94 },
            { timeNo: '2024-08-06T22:00:00.0000000Z', value: 10.94 },
        ],
        volume: [
            { timeNo: '2024-08-05T00:00:00.0000000Z', value: 10.27 },
            { timeNo: '2024-08-05T01:00:00.0000000Z', value: 9.52 },
            { timeNo: '2024-08-05T02:00:00.0000000Z', value: 9.08 },
        ],
        weight: [
            { timeNo: '2024-08-05T01:00:00.0000000Z', value: 9.52 },
            { timeNo: '2024-08-05T00:00:00.0000000Z', value: 10.27 },
            { timeNo: '2024-08-05T02:00:00.0000000Z', value: 9.08 },
        ],
    };

    useEffect(() => {
        if (props.processFlowConfigs.result === undefined) {
            props.getAllConfigs(true);
        }
    }, []);

    useEffect(() => {
        props.setSofView(SofView.Nomination);
    }, []);

    const renderDetailsCell = (key: string, value: string, suffix?: string) => {
        if (key === 'status') {
            return (
                <div className="d-flex">
                    <div className="value-tank-status">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.99996 11.3337C4.51107 11.3337 3.24996 10.817 2.21663 9.78366C1.18329 8.75033 0.666626 7.48921 0.666626 6.00033C0.666626 4.51144 1.18329 3.25033 2.21663 2.21699C3.24996 1.18366 4.51107 0.666992 5.99996 0.666992C6.76663 0.666992 7.49996 0.825326 8.19996 1.14199C8.89996 1.45866 9.49996 1.91144 9.99996 2.50033V0.666992H11.3333V5.33366H6.66663V4.00033H9.46663C9.11107 3.3781 8.62496 2.88921 8.00829 2.53366C7.39163 2.1781 6.72218 2.00033 5.99996 2.00033C4.88885 2.00033 3.9444 2.38921 3.16663 3.16699C2.38885 3.94477 1.99996 4.88921 1.99996 6.00033C1.99996 7.11144 2.38885 8.05588 3.16663 8.83366C3.9444 9.61144 4.88885 10.0003 5.99996 10.0003C6.85552 10.0003 7.62774 9.75588 8.31663 9.26699C9.00552 8.7781 9.48885 8.13366 9.76663 7.33366H11.1666C10.8555 8.51144 10.2222 9.47255 9.26663 10.217C8.31107 10.9614 7.22218 11.3337 5.99996 11.3337Z" fill="white" />
                        </svg>
                        {capitalizeFirstLetterPerWord(value)}
                    </div>
                </div>
            );
        }
        if (key === 'mode') {
            return (
                <div className="d-flex">
                    <div className="value-tank-status">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_394_16976" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                                <rect width="16" height="16" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_394_16976)">
                                <path d="M10.2333 10.8329L11.0833 9.98294L8.59998 7.49961V3.99961H7.39998V7.99961L10.2333 10.8329ZM7.99998 14.3996C7.11798 14.3996 6.28914 14.2329 5.51348 13.8996C4.73781 13.5663 4.05831 13.1079 3.47498 12.5246C2.89164 11.9413 2.43331 11.2609 2.09998 10.4836C1.76664 9.70628 1.59998 8.87572 1.59998 7.99194C1.59998 7.10817 1.76664 6.27739 2.09998 5.49961C2.43331 4.72183 2.89164 4.04405 3.47498 3.46628C4.05831 2.8885 4.73864 2.43294 5.51598 2.09961C6.29331 1.76628 7.12386 1.59961 8.00764 1.59961C8.89142 1.59961 9.72225 1.76761 10.5001 2.10361C11.2779 2.43961 11.9545 2.89561 12.53 3.47161C13.1053 4.04761 13.5608 4.72494 13.8965 5.50361C14.2321 6.28228 14.4 7.11428 14.4 7.99961C14.4 8.88161 14.2333 9.71044 13.9 10.4861C13.5666 11.2618 13.1111 11.9413 12.5333 12.5246C11.9555 13.1079 11.277 13.5663 10.4978 13.8996C9.71859 14.2329 8.88598 14.3996 7.99998 14.3996ZM8.00798 13.1996C9.44653 13.1996 10.6715 12.6913 11.683 11.6746C12.6943 10.6579 13.2 9.43028 13.2 7.99161C13.2 6.55305 12.6943 5.32805 11.683 4.31661C10.6715 3.30528 9.44653 2.79961 8.00798 2.79961C6.56931 2.79961 5.34164 3.30528 4.32498 4.31661C3.30831 5.32805 2.79998 6.55305 2.79998 7.99161C2.79998 9.43028 3.30831 10.6579 4.32498 11.6746C5.34164 12.6913 6.56931 13.1996 8.00798 13.1996Z" fill="white" />
                            </g>
                        </svg>
                        {capitalizeFirstLetterPerWord(value)}
                    </div>
                </div>
            );
        }
        if (suffix) {
            return (
                <>
                    {value}
                    <span className="value-tank-available"> {suffix}</span>
                </>
            )
        }
        return !['', null, undefined].includes(value) ? value : '-';
    }

    return (
        <>
            <div className="section bg-light" style={{ height: "100%", overflow: 'auto' }}>
                <div className="details-header">
                    <div className="header-section">
                        <Link to="/tank">
                            <button type="button" className="btn btn-light rounded-circle"><FaArrowLeft /></button>
                        </Link>
                        <span>{tank}</span>
                    </div>
                    <div className="header-section">
                        <NominationDetailBtn disabled={tankDetails.mode === 'IDLE'} nomination={nomination.nominationDetails} />
                        <button type="button" className="btn btn-light rounded-circle"><AiOutlineSetting /></button>
                    </div>
                </div>
                <TankDisclaimer />
                <div className="row px-3">
                    <div className="col pl-0">
                        <div className="p-3 bg-white rounded-lg border h-full">
                            <div className="d-flex w-full justify-content-between">
                                <div className="d-flex gap p-0">
                                    <div className="details-trend-up"><IoIosTrendingUp /></div>
                                    <div className="d-flex details-tank-icons">
                                        {alarm === 'Leak Detect' && <div className="details-leak-detect"><AiOutlineWarning />Leak Detect</div>}
                                    </div>
                                </div>
                                <div className="d-flex p-0">
                                    <div className="details-flow-direction">
                                        Flow Direction
                                        <div className="details-flow-status">
                                            <FaRegStopCircle />
                                            Static
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="py-2">
                                <div className="d-flex justify-content-center">
                                    <img alt={`Tank Level ${((criticalMeasurements.level.processValue / criticalMeasurements.level.valueMax) * 10).toFixed(0)}`} width={230} height={230} src={`tank-levels/tank-level-${((criticalMeasurements.level.processValue / criticalMeasurements.level.valueMax) * 10).toFixed(0)}.svg`} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col p-0">
                        <div className="p-3 bg-white rounded-lg border h-full">
                            <div className="section-header">
                                Critical Measurements
                            </div>
                            <div className="pt-3">
                                {criticalMeasureFields.map(({ key, ...rest }) => (
                                    <CriticalMeasureGauge key={key} {...criticalMeasurements[key]} iconLabel={key} {...rest} />
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col pr-0">
                        <div className="p-3 bg-white rounded-lg border h-full">
                            <div className="section-header">
                                Tank Details
                            </div>
                            <table className="details-table">
                                <tbody>
                                    {tankDetailFields.map(({ key, label, suffix }) => (
                                        <tr key={key} >
                                            <td className="label" style={{ width: '25%' }}>{label}</td>
                                            <td className="value">{renderDetailsCell(key, tankDetails?.[key], suffix)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <TankHistoricalChart {...{ data: chartData }} />
            </div>
        </>
    );
};
export default connect(
    (state: State) => ({
        ...state.activityLogs,
        ...state.authentication,
        ...state.general,
        ...state.lineHandling,
        ...state.offlineData,
        ...state.processFlowConfigState,
        ...state.sofView,
        ...state.workPacket,
    }),
    {
        ...ActivityLogsStore.actionCreators,
        ...OfflineDataStore.actionCreators,
        ...ProcessFlowConfigStore.actionCreators,
        ...SofViewStore.actionCreators,
        ...GeneralStore.actionCreators,
        ...WorkPacketStore.actionCreators,
    }
)(TankSofPage as any);
